module.exports = __webpack_public_path__ + "static/media/um.aefba3fe.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/um.svg
// module id = 277
// module chunks = 0